// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__6G_gf","name":"Card_name__4RGOc","img":"Card_img__2N4kY","types":"Card_types__1ycLI"};